<template>
  <div class="row">
    <div style="text-align: center">
      <h3 v-if="!hata">Bu anket tamamlandı veya henüz başlamadı.</h3>
      <h3 v-if="hata">{{hata}}</h3>
    </div>
  </div>
</template>

<script>

export default {
  props: ["hata"],
  name: 'Hata',
  components: {
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
